var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":_vm.iconSrc,"title":_vm._f("channelType")(_vm.channel.type)}})}
var staticRenderFns = []

export { render, staticRenderFns }